var map = {
	"./AmpliTeach_white.png": 48,
	"./Ic_practice time.svg": 180,
	"./Singing Teacher-595b40b75ba036ed117d8efe 1.svg": 181,
	"./ampliTeach.svg": 35,
	"./arrow_down_black.svg": 123,
	"./arrow_right_white.svg": 79,
	"./assign_practice.svg": 182,
	"./attachment.svg": 131,
	"./attendance_icon.svg": 183,
	"./audio_bg.svg": 230,
	"./audio_play.svg": 231,
	"./backward_btn_icon.svg": 165,
	"./bars-progress-solid.svg": 232,
	"./book_open.svg": 184,
	"./build_my_biz_icon.svg": 185,
	"./calender_icon.svg": 147,
	"./call_icon_white.svg": 132,
	"./cart_icon.svg": 186,
	"./category.svg": 187,
	"./check-solid.svg": 233,
	"./choose_from_library.svg": 234,
	"./communication_log_icon.svg": 188,
	"./complete_Practice.svg": 189,
	"./course_img_i.jpg": 155,
	"./course_img_ii.jpg": 235,
	"./courses_graphic.png": 166,
	"./create_course_lesson.svg": 172,
	"./crossIcon.png": 236,
	"./csv_icon.svg": 151,
	"./dashboard_icon_red.svg": 153,
	"./dashboard_icon_white.svg": 237,
	"./data_not_found.svg": 121,
	"./delete.svg": 173,
	"./delete_white.svg": 133,
	"./doc.svg": 134,
	"./download.png": 238,
	"./download_red.svg": 119,
	"./download_white.png": 135,
	"./dummy.pdf": 190,
	"./empty_cart.svg": 191,
	"./file_example_MP4_480_1_5MG.mp4": 239,
	"./grid_black_icon.svg": 192,
	"./grid_red_icon.svg": 193,
	"./group_icon.png": 240,
	"./help_icon.svg": 136,
	"./ic_View_schedule.svg": 194,
	"./ic_access_practice.svg": 195,
	"./ic_message.svg": 196,
	"./icon_add_file_links.jpg": 241,
	"./icon_audio_pause.svg": 152,
	"./icon_audio_play.svg": 149,
	"./icon_calendar.svg": 242,
	"./icon_choose_file.jpg": 197,
	"./icon_clock.svg": 75,
	"./icon_clock_black.svg": 198,
	"./icon_cross_white.svg": 80,
	"./icon_date_black.png": 243,
	"./icon_date_red.png": 244,
	"./icon_date_red.svg": 154,
	"./icon_date_white.png": 245,
	"./icon_document.svg": 126,
	"./icon_dots_vertical.svg": 122,
	"./icon_guitar.svg": 246,
	"./icon_monthly_black.png": 247,
	"./icon_monthly_white.png": 248,
	"./icon_mp3.svg": 128,
	"./icon_payment.svg": 249,
	"./icon_pdf.svg": 250,
	"./icon_select_course.jpg": 174,
	"./icon_teacher.svg": 251,
	"./icon_timer_pause.svg": 252,
	"./icon_timer_play.svg": 253,
	"./icon_timer_stop.svg": 81,
	"./icon_week_black.png": 254,
	"./icon_week_red.svg": 255,
	"./icon_week_white.png": 256,
	"./icon_youtube.jpg": 167,
	"./image.svg": 129,
	"./image_upload.svg": 257,
	"./inner_profile_pic.png": 258,
	"./intstrument.jpg": 259,
	"./invalid_icon.svg": 260,
	"./invite.svg": 150,
	"./invoice_bottom_left_red_bg.svg": 261,
	"./invoice_top_right_red_bg.svg": 262,
	"./learning_icon_red.svg": 263,
	"./learning_icon_white.svg": 264,
	"./list_black_icon.svg": 199,
	"./list_red_icon.svg": 200,
	"./login_bg_left.svg": 265,
	"./login_bg_right.svg": 266,
	"./login_desc_bg.jpg": 267,
	"./login_widget_vector.svg": 201,
	"./mail_icon_white.svg": 137,
	"./member-1.png": 268,
	"./member-2.png": 269,
	"./member-3.png": 270,
	"./member-4.png": 271,
	"./members_icon_red.svg": 272,
	"./members_icon_white.svg": 273,
	"./message_icon.svg": 138,
	"./minus.svg": 274,
	"./modal_cross_icon.svg": 57,
	"./modal_cross_icon_gray.svg": 139,
	"./modal_cross_icon_white.svg": 120,
	"./msg_read_dtick.png": 140,
	"./musical-note-variant-with-thin-outline-svgrepo-com.svg": 202,
	"./no_course_for_approval.svg": 156,
	"./no_data_found_calander.svg": 203,
	"./no_notification_image.svg": 204,
	"./notification_blank_icon.svg": 141,
	"./notification_icon.svg": 142,
	"./notification_icon_white.svg": 175,
	"./order_1.png": 275,
	"./order_2.png": 276,
	"./order_3.png": 277,
	"./order_4.png": 278,
	"./payments_icon.svg": 205,
	"./payroll_icon.svg": 206,
	"./pdf.svg": 124,
	"./pdf_icon.svg": 125,
	"./play_arrow.png": 161,
	"./practice_video_icon.svg": 157,
	"./profile_pic.png": 279,
	"./progressbar_rounded_green.svg": 148,
	"./progressbar_rounded_red.svg": 280,
	"./question-sign-in-circles-svgrepo-com.svg": 207,
	"./question-svgrepo-com.svg": 281,
	"./recent_activity_1.jpg": 162,
	"./recent_activity_2.jpg": 176,
	"./recent_activity_3.jpg": 163,
	"./recent_activity_4.jpg": 177,
	"./recent_activity_5.jpg": 168,
	"./reporting_graphic.png": 282,
	"./reporting_icon_red.svg": 283,
	"./reporting_icon_white.svg": 284,
	"./schedualing_icon_red.svg": 285,
	"./schedualing_icon_white.svg": 286,
	"./school_icon.svg": 208,
	"./search_icon.svg": 118,
	"./select.png": 169,
	"./select_down_arrow.svg": 209,
	"./send.svg": 143,
	"./setting.svg": 130,
	"./smile.svg": 144,
	"./sms_icon_white.svg": 145,
	"./store_icon.svg": 210,
	"./store_loader_icon.svg": 211,
	"./stud_billing_icon_red.svg": 287,
	"./stud_billing_icon_white.svg": 288,
	"./student_myFavourite.svg": 212,
	"./student_practice_assigned.svg": 213,
	"./student_profile_pic.png": 289,
	"./student_report_icon.svg": 214,
	"./students_graphic.png": 158,
	"./success_true_tick.svg": 178,
	"./support_graphic.png": 63,
	"./support_icon.svg": 82,
	"./system_drop_down_list.svg": 215,
	"./teacher_dashboard_banner_vector.svg": 290,
	"./teacher_report.svg": 216,
	"./teachers_graphic.png": 170,
	"./teachers_profile_pic.png": 291,
	"./thumbnail.jpg": 39,
	"./triangle-exclamation-solid.svg": 292,
	"./true_tick.svg": 293,
	"./two_arrows.svg": 294,
	"./upload.png": 179,
	"./waving-hand.png": 146,
	"./welcome_chat_bg.png": 295,
	"./welcome_graphic.png": 296,
	"./word_icon.svg": 164,
	"./xmark-solid.svg": 159,
	"./youtube.svg": 127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 229;